<template>
  <v-card
    tag="article"
    class="video-card-large"
    :to="to"
    color="transparent"
    flat
    tile
    height="100"
  >
    <img :src="img" :alt="title" loading="lazy" @error="invalidImage = true" />
    <div
      class="
        video-card-large-content
        d-flex
        flex-column
        justify-start
        align-start
        pl-4
      "
    >
      <h2 :class="['text-h6 font-weight-black mb-2', dark && 'white--text']">
        <span class="roboto-condensed">
          {{ slicedTitle }}
        </span>
      </h2>
      <time
        :class="[
          'text-body-2  font-weight-bold',
          !dark ? 'grey--text text--darken-2' : 'white--text',
        ]"
        v-if="localeDate"
        :datetime="ISODate"
      >
        {{ localeDate }}
      </time>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    ISODate: {
      type: String,
      required: true,
    },
    localeDate: {
      type: String,
      required: true,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    invalidImage: false,
  }),
  computed: {
    slicedTitle() {
      return this.title.length > 80
        ? this.title.slice(0, 80) + "..."
        : this.title;
    },
  },
};
</script>

<style>
.video-card-large {
  display: grid;
  grid-template-columns: max-content auto;
}
.video-card-large h2 {
  overflow: hidden;
  line-height: 24px !important;
}
.video-card-large img {
  height: 100px;
  object-fit: cover;
  aspect-ratio: 12/8;
}
</style>
